import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "big-main",
  class: "flex flex-col items-stretch"
}

import LandingPageHeader from '@/components/landing-page/LandingPageHeader.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'LandingPageView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(LandingPageHeader, { class: "flex-initial" }),
    _createVNode(_component_router_view)
  ]))
}
}

})